import { CSSProperties, ReactNode } from 'react';

type Props = {
    title: string;
    children: ReactNode;
    style?: CSSProperties;
    className?: string;
};

const Fieldset = ({ title, children, style, className }: Props) => {
    return (
        <>
            <p>{title}</p>
            <fieldset
                style={style}
                className={className}
            >
                <legend>{title}</legend>
                {children}
            </fieldset>
        </>
    );
};

export default Fieldset;
